let projeDetay = null;

const setProjeDetayHandler = (detay) => {
  projeDetay = detay;
};

const getProjeDetayHandler = () => projeDetay;

export { setProjeDetayHandler, getProjeDetayHandler };
